export default __webpack_public_path__ + "static/media/Close.42159171.svg";